import styled from 'styled-components';
import { LinkButton } from '../../CommonComponents/Button';

export const Container = styled.section`
  position: relative;
  padding: 0;
  text-align: center;
  page-break-inside: avoid;
  page-break-after: always;
`;

export const HeaderContainer = styled.div`
  margin: 0 0 20px 0;
  position: relative;
  text-align: left;
`;

export const HeaderTitle = styled.h2`
  margin: 0 0 20px 0;
  font-weight: 600;
  color: #444;
  font-size: 24px;
  line-height: 45px;
  text-align: left;
`;

export const DropdownMenu = styled.ul`
  margin: 0;
  padding: 0;
  border: 2px solid #ddd;
  overflow: visible;
  border-left: none;
  border-right: none;

  position: absolute;
  top: 0;
  right: 0;
`;

export const DropdownMenuFirstItem = styled.li<{
  isSelected: boolean;
}>`
  display: block;
  float: left;
  padding: 0 20px;
  margin: 0;
  font-size: 15px;
  text-transform: uppercase;
  font-weight: 600;
  line-height: 40px;
  overflow: visible;
  cursor: pointer;
  position: relative;

  color: ${props => (props.isSelected ? '#0078D4' : '#6C727F')};

  &:hover {
    background: #f9f9f9;
    color: #0078d4;
    ul {
      display: block;
    }
  }

  ul {
    margin: 0 0 0 -20px;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: right;
    left: auto;
    right: 0;
    width: 280px;
    max-height: 512px;
    overflow-y: auto;
    box-shadow: 0 1px 3px hsla(0, 0%, 0%, 0.12), 0 1px 2px hsla(0, 0%, 0%, 0.24);
    padding: 6px 0;
  }
`;

interface DropdownMenuSecondItemProps {
  isSelected: boolean;
}
export const DropdownMenuSecondItem = styled.li<DropdownMenuSecondItemProps>`
  text-transform: none;
  padding: 0 !important;
  background: ${({ isSelected }) => isSelected && '#f2f9ff'};

  &&& {
    &:hover {
      background: #f2f9ff;
    }
  }
`;

export const DropdownMenuButton = styled(LinkButton)`
  width: 100%;
  height: 100%;
  padding: 10px 20px;
  border-radius: 0;
  text-align: left;
`;

export const DropdownItemText = styled.div`
  width: 240px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 24px;
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    margin: 5px 0 0 10px;
    padding: 0;
    float: left;
    line-height: 31px;
    color: #6c727f;
    font-size: 14px;
  }
`;

interface Props {
  twoColumns?: boolean;
}

export const PortfolioDetailsContainer = styled.div<Props>`
  align-items: stretch;
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: ${props => (props.twoColumns ? 'flex-start' : 'center')};
`;

export const PortfolioDetailsSpacer = styled.div`
  width: 50%;
`;

export const PortfolioDetailsContent = styled.div`
  width: 50%;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0;
  box-sizing: border-box;
  position: relative;
  text-align: left;
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  background: #fff;
`;

export const PortfolioDetailsTitle = styled.h2<{ isProposed: boolean }>`
  display: block;
  color: #383c42;
  font-size: 17px;
  margin: 0;
  padding: 20px;
  font-weight: 300;
  span {
    float: right;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 15px;
    color: ${props => (props.isProposed ? '#0078D4' : '#6C727F')};
  }
`;

export const BodyContainer = styled.div`
  flex-grow: 1;
`;

export const ChartContainer = styled.div`
  width: 40%;
  height: 165px;
  max-width: 165px;
  float: left;
  margin: 0 0 0 10px;
`;

export const Amount = styled.div`
  width: 100%;
  text-align: center;
  display: block;
  font-weight: 600;
  color: #333;
  font-size: 20px;
  margin: 5px 0 0 0;
`;

export const LabelsContainer = styled.div`
  float: right;
  width: 50%;
  margin: 0;
  padding: 0;
  min-height: 235px;
  box-sizing: border-box;

  ul {
    display: block;
    margin: 0 0 20px 0;
    padding: 0;
  }
`;

export const LabelsItem = styled.li<{
  isInactive?: boolean;
  isPrimary?: boolean;
  isTruncated?: boolean;
}>`
  font-size: 14px;
  color: ${props => (props.isInactive ? '#494f5a' : '#383C42')};
  margin: ${props => (props.isPrimary ? '15px 0 0 0' : '0')};
  position: relative;

  padding: 5px 15px;
  display: flex;
  vertical-align: middle;

  &:first-child {
    margin: 0;
  }

  i {
    display: block;
    position: absolute;
    width: 14px;
    height: 14px;
    left: -10px;
    border-radius: 7px;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  ${props => {
    if (props.isTruncated) {
      return `      
        color: #383C42;
        font-weight: 700;
        font-style: italic;
        font-size: 16px;
      `;
    }
    return '';
  }}
`;

export const Label = styled.div`
  flex: 1;
  padding-right: 4px;
`;

export const Indicators = styled.ul`
  clear: both;
  float: none;
  margin: 0;
  padding: 0;

  li {
    display: flex;
    padding: 0;
    line-height: 1;
    position: relative;
    font-size: 20px;
    font-weight: 600;
    color: #555;
    border-top: 1px solid #ddd;

    p {
      width: 40%;
      display: block;
      font-size: 13px;
      color: #6c727f;
      padding: 16px 20px;
      box-sizing: border-box;
      text-transform: uppercase;
      line-height: 1.3;
      margin: 0;
    }

    div {
      width: 60%;
      padding: 16px 20px;
      box-sizing: border-box;
      text-align: right;
    }

    &:last-child {
      background: #eee;
      color: #333;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      p {
        color: #383c42;
      }
    }

    &:first-child {
      color: #0078d4;
      p {
        color: #6c727f;
      }
    }
  }
`;

export const LinkBlueButton = styled(LinkButton)`
  color: #0078d4;
  margin-top: 40px;
  font-size: 18px;
`;
